import {Theme} from '@mui/material/styles';

export default function DialogContent(theme: Theme) {
  return {
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: '16px 32px 32px',
          fontSize: '22px',
          color: theme.palette.common.black,
          [theme.breakpoints.down('sm')]: {
            padding: '16px 24px',
          },
        },
      },
    },
  };
}
